// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc, TradePartnerContactFragmentDoc, TradePartnerFragmentDoc, HistoryFeedInfoFragmentDoc, ChangeEventTypeFragmentDoc } from '../../../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BulkEditModal_GetTlisQueryVariables = Types.Exact<{
  filter: Types.TakeoffLineItemFilter;
  versionId: Types.Scalars['ID']['input'];
}>;


export type BulkEditModal_GetTlisQuery = { __typename?: 'Query', takeoffLineItemsPage: { __typename?: 'TakeoffLineItemsPage', items: Array<{ __typename?: 'TakeoffLineItem', id: string, costType: Types.CostType, canEditLocation: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> } };

export type BulkEditModal_TliFragment = { __typename?: 'TakeoffLineItem', id: string, costType: Types.CostType, canEditLocation: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export const BulkEditModal_TliFragmentDoc = gql`
    fragment BulkEditModal_Tli on TakeoffLineItem {
  id
  costType
  canEditLocation {
    ...PotentialOperationDetails
  }
}
    ${PotentialOperationDetailsFragmentDoc}`;
export const BulkEditModal_GetTlisDocument = gql`
    query BulkEditModal_GetTlis($filter: TakeoffLineItemFilter!, $versionId: ID!) {
  takeoffLineItemsPage(filter: $filter, versionId: $versionId) {
    items {
      ...BulkEditModal_Tli
    }
  }
}
    ${BulkEditModal_TliFragmentDoc}`;

/**
 * __useBulkEditModal_GetTlisQuery__
 *
 * To run a query within a React component, call `useBulkEditModal_GetTlisQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkEditModal_GetTlisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkEditModal_GetTlisQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useBulkEditModal_GetTlisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BulkEditModal_GetTlisQuery, BulkEditModal_GetTlisQueryVariables> & ({ variables: BulkEditModal_GetTlisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BulkEditModal_GetTlisQuery, BulkEditModal_GetTlisQueryVariables>(BulkEditModal_GetTlisDocument, options);
      }
export function useBulkEditModal_GetTlisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BulkEditModal_GetTlisQuery, BulkEditModal_GetTlisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BulkEditModal_GetTlisQuery, BulkEditModal_GetTlisQueryVariables>(BulkEditModal_GetTlisDocument, options);
        }
export function useBulkEditModal_GetTlisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkEditModal_GetTlisQuery, BulkEditModal_GetTlisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BulkEditModal_GetTlisQuery, BulkEditModal_GetTlisQueryVariables>(BulkEditModal_GetTlisDocument, options);
        }
export type BulkEditModal_GetTlisQueryHookResult = ReturnType<typeof useBulkEditModal_GetTlisQuery>;
export type BulkEditModal_GetTlisLazyQueryHookResult = ReturnType<typeof useBulkEditModal_GetTlisLazyQuery>;
export type BulkEditModal_GetTlisSuspenseQueryHookResult = ReturnType<typeof useBulkEditModal_GetTlisSuspenseQuery>;
export type BulkEditModal_GetTlisQueryResult = Apollo.QueryResult<BulkEditModal_GetTlisQuery, BulkEditModal_GetTlisQueryVariables>;